import styled from 'styled-components';
import constants from '../../../core/constants';

// MOBILE FIRST
const WrapFullEmtpyDates = styled.div`
  height: calc(100vh - 105px);
  width: 100%;
  max-width: 296px;
  background: var(--background-background-UTP);
  h3 {
    min-height: 48px;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-top: 57px;
  }
`;

const WrapFullEmtpyDatesBackground = styled.img`
  height: 100vh;
  width: 100%;
  display: inline-block;
`;

const WrapTodayEmtpyDates = styled.div`
  height: 136px;
  width: 100%;
  padding: 16px 24px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  background: #ffffff;
  box-shadow: 0 2px 8px -4px rgba(176, 192, 202, 0.2);
  margin-top: 16px;
  h3 {
    font-size: 14px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
  }
`;

const WrapTodayEmtpyDatesBackground = styled.img`
  height: 104px;
  width: 104px;
  display: inline-block;
`;

const WrapHeading = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  font-family: Lato;
  font-size: 14px;
  font-weight: 900;
  padding: 12px 24px;
  padding-left: 0px;

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapItem = styled.div.attrs((pr: any) => ({
  isItemSelected: pr.isItemSelected
}))`
  width: 100%;
  height: auto;
  background: ${(p) =>
    p.isItemSelected ? 'var(--background-background02)' : '#ffffff'};
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px -4px rgba(176, 192, 202, 0.2);
  margin-bottom: 8px;
  // &:last-child {
  // box-shadow: 0 2px 8px -4px rgba(176, 192, 202, 0.2);
  // }
  &:first-child {
    margin-top: 12px;
  }
  &.item-active {
    background: var(--background-background02);
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const TitleItem = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-text02);
  word-wrap: break-word;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const DatesItem = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  color: var(--text-text01);
  font-size: 12px;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const DetailsItem = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  color: var(--neutral-03);
  font-size: 12px;
  a {
    color: var(--text-primary);
    margin-left: 4px;
  }
  span {
    color: var(--text-primary);
    margin-left: 4px;
  }

  a,
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapCollection = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
`;

export {
  WrapFullEmtpyDates,
  WrapFullEmtpyDatesBackground,
  WrapTodayEmtpyDates,
  WrapTodayEmtpyDatesBackground,
  WrapHeading,
  WrapItem,
  WrapCollection,
  DetailsItem,
  TitleItem,
  DatesItem
};
